import React from "react";
import LoadingSpinner from "../loader/LoadingSpinner";

export default function Button(props) {
  const { buttonTitle, isLoading, ...restProps } = props;

  return (
    <button
      {...restProps}
      className={`buttonX ${props.className ?? ""}`}
      type={props.type ?? "submit"}
    >
      {isLoading && <LoadingSpinner className="me-2" />}
      {buttonTitle}
      {props.children}
    </button>
  );
}
